import { toastStore } from '@services/ToastStore';

class NotificationService {
  public success(text: string){
    toastStore.success(text);
  }

  public error(text: string){
    toastStore.error(text);
  }
}

export const notificationService = new NotificationService();